// removed by extract-text-webpack-plugin
module.exports = {"main-list":"main_nav-aoe","sub-list":"main_nav-3jc"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/LinkList/link_list.module.scss
// module id = 358
// module chunks = 0